// extracted by mini-css-extract-plugin
export default {"card":"CardContent_card__Y1Su4"};